var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfolio_list_wrap"},[_c('member-detail-component',{attrs:{"memberType":'memberPortfolio',"memberKey":_vm.memberKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }